import { getWebPath } from '@doss/common-all'
import { Stack } from '@mui/material'
import Bluebird from 'bluebird'
import { compact } from 'lodash'
import { Children, useEffect, useState } from 'react'
import {
  BreadcrumbObjectType,
  useGetFileCellDocumentLazyQuery,
} from '~/common/generated/apollo-operations'
import { FileCellDocument } from '~/components/records/record-cell-details/types'
import { FileChip } from '~/components/ui/molecules/file-chip/FileChip'
import { useGlobalContext } from '../../../common/hooks/useGlobalContext'
import { SignatureChip } from '../../ui/molecules/file-chip/SignatureChip'
import { FileInlineImage } from '../FileTableCells/FileInlineImage'

interface FileTableCellProps {
  value: string[]
  displayImage: boolean
}

/**
 * Renders table cell for a column of type ARRAY with inner type File
 */
export const FileArrayTableCell = ({ value, displayImage }: FileTableCellProps) => {
  const [getFile] = useGetFileCellDocumentLazyQuery()
  const [files, setFiles] = useState<FileCellDocument[]>([])
  const { user } = useGlobalContext()

  useEffect(() => {
    const getAllFiles = async (documentIds: string[]) => {
      return Bluebird.map(documentIds, (documentId) =>
        getFile({
          variables: {
            documentId,
          },
        }),
      )
    }

    getAllFiles(value).then((results) => {
      setFiles(compact(results.map((result) => result.data?.document)))
    })
  }, [getFile, value])

  const fileContent = (file: FileCellDocument) => {
    if (file.signature) {
      return <SignatureChip document={file} signature={file.signature} />
    } else if (displayImage) {
      return <FileInlineImage document={file} />
    } else {
      return (
        <FileChip
          document={file}
          fileName={file.name}
          fileUrl={getWebPath({
            objectId: file.id,
            objectType: BreadcrumbObjectType.DOCUMENT,
            isUnauth: !user,
          })}
        />
      )
    }
  }

  return (
    <Stack direction="row" spacing={1}>
      {Children.toArray(files.map((file) => fileContent(file)))}
    </Stack>
  )
}
